import moment from 'moment';

export function chatting_date_function(date) {
    const div = new Date(date).getHours();
    return div >= 12 ? '오후 ' + moment(date).format('hh:mm') : '오전 ' + moment(date).format('hh:mm');
}

const chatKSTFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
});

export function formatChatTimestamp(value) {
    if (typeof value !== 'string' || !value.trim()) return '-';
    const text = value.trim();
    const naive = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(text);
    const date = new Date(naive ? `${text.replace(' ', 'T')}Z` : text);
    if (!Number.isFinite(date.getTime())) return '-';
    const parts = Object.fromEntries(chatKSTFormatter.formatToParts(date).map(({ type, value }) => [type, value]));
    return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
}
